import { Route, RouteComponentProps } from "wouter";
import { ComponentType } from "react";
import { AuthenticatedRoute } from "../AuthenticatedRoute/AuthenticatedRoute";
import env from "@/env";

type ConditionalAuthRouteProps = {
  path: string;
  component: ComponentType<RouteComponentProps>;
  requiresState?: unknown;
};

export const ConditionalAuthRoute: React.FC<ConditionalAuthRouteProps> = (props) => {
  if (env.FEATUREFLAG_DELAYED_LOGIN) {
    return <Route path={props.path} component={props.component} />;
  }
  return <AuthenticatedRoute {...props} />;
};
